import { useState, useContext } from 'react';
import { UnicornApiContext } from '../../UnicornApi.context';
import { DisplayAssetsFormData } from '../../types';

export const useAssetVisibility = () => {
  const { unicornApi } = useContext(UnicornApiContext);
  const isUnicornApiAvailable = Boolean(unicornApi);
  const isImpersonationActive = isUnicornApiAvailable && unicornApi?.data.user.impersonationActive;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState<DisplayAssetsFormData>({ details: '', justification: 'other' });
  const assetViewMode = unicornApi?.data.assetVisibility;

  const onEyeButtonClick = () => {
    if (assetViewMode === 'visible') {
      unicornApi?.__internal.disableVisibilityStatus();
    } else {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = () => {
    setIsModalOpen(false);
    if (assetViewMode === 'notVisible') {
      // FIXME: UI for this should be later part of "Unicorn app", removing need for cross-app calls through "internal" method
      unicornApi?.__internal.enableVisibilityStatus(formData.details, formData.justification);
    }
    setFormData({ details: '', justification: 'other' });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChange = (data: DisplayAssetsFormData) => {
    setFormData(data);
  };

  return {
    onEyeButtonClick,
    handleCloseModal,
    handleSubmit,
    handleChange,
    handleCancel,
    isModalOpen,
    formData,
    assetViewMode,
    isImpersonationActive,
  };
};
